import { Application, coreResources, Injection } from '@siposdani87/sui-js';
import { config } from './config';

const serviceNames = Object.keys(
    import.meta.glob('./services/*Service.ts'),
).map((path) => path.match(/\.\/services\/(.+)\.ts/)![1]);

const controllerNames = Object.keys(
    import.meta.glob('./controllers/*Controller.ts'),
).map((path) => path.match(/\.\/controllers\/(.+)\.ts/)![1]);

const resources: Injection = {
    ...coreResources,
    ...Object.fromEntries(
        [...serviceNames, ...controllerNames].map((k) => [k, k]),
    ),
};

export const app = new Application(config, resources);
